import * as Yup from "yup";
import { emailRegex, nameRegex, phoneNoRegex } from "../../configs/App.Regex";

export const state = {
  first_name: "",
  last_name: "",
  gender: "",
  dob: "",
  country_code: "+91",
  phone_no: "",
  email: "",
  org_code: null,
  password: "",
  confirm_password: "",
};

const nameField = (requiredKey, invalidKey, t) =>
  Yup.string()
    .trim()
    .required(`${t(requiredKey)}`)
    .matches(nameRegex, `${t(invalidKey)}`)
    .max(100, `${t("authPages:max_100_characters")}`);

export const schema = (t) =>
  Yup.object().shape({
    first_name: nameField(
      "authPages:first_name_required",
      "authPages:invalid_first_name",
      t,
    ),
    last_name: nameField(
      "authPages:last_name_required",
      "authPages:invalid_last_name",
      t,
    ),
    gender: Yup.string().notRequired(),
    dob: Yup.date().notRequired(),
    country_code: Yup.string().notRequired(),
    phone_no: Yup.string()
      .notRequired()
      .test(
        "phone-format",
        `${t("authPages:invalid_phone_number")}`,
        function (value) {
          if (!value || value.trim() === "") {
            return true;
          }
          return phoneNoRegex.test(value);
        },
      ),
    email: Yup.string()
      .trim()
      .required(`${t("authPages:email_required")}`)
      .matches(emailRegex, `${t("authPages:invalid_email")}`)
      .max(100, `${t("authPages:max_100_characters")}`),
    password: Yup.string()
      .required(`${t("authPages:password_required")}`)
      .matches(/^(?=.*[A-Z])/, `${t("authPages:password_uppercase")}`)
      .matches(/^(?=.*[a-z])/, `${t("authPages:password_lowercase")}`)
      .matches(/^(?=.*\d)/, `${t("authPages:password_number")}`)
      .matches(
        /^(?=.*[~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/])/,
        `${t("authPages:password_special_char")}`,
      )
      .min(8, `${t("authPages:password_min_length")}`)
      .max(100, `${t("authPages:max_100_characters")}`),
    confirm_password: Yup.string()
      .required(`${t("authPages:confirm_password_required")}`)
      .oneOf([Yup.ref("password")], `${t("authPages:passwords_mismatch")}`)
      .max(100, `${t("authPages:max_100_characters")}`),
    org_code: Yup.string().notRequired(),
  });
